export enum FormMode {
  Readonly = 1,
  Edit = 2,
  Create = 3,
}

export default FormMode;
